module.exports = __webpack_public_path__ + "media/scholarship_winners/amanda-b-56b0ad7e.png";